var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.desserts,"items-per-page":5,"show-select":"","value":_vm.selected,"item-key":"name"}})}
var staticRenderFns = []

export { render, staticRenderFns }